import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withFadeInUpAnimation from '../../hocs/withFadeInUpAnimation'
import CardTitle from '../typography/CardTitle'

export class BlankCard extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
    notCard: PropTypes.bool,
    noPad: PropTypes.bool,
    title: PropTypes.string,
  }

  static defaultProps = {
    notCard: false,
    noPad: false,
    title: '',
  }

  render() {
    const { children, notCard, title, noPad, ...rest } = this.props

    if (notCard)
      return (
        <div {...rest}>
          {title.length ? <CardTitle content={title} /> : null}
          {children}
        </div>
      )

    return (
      <div {...rest}>
        <div className="card shadow">
          <div className={noPad ? '' : 'card-body'}>
            {title && <h6 style={{ marginBottom: 10 }}>{title}</h6>}
            {children}
          </div>
        </div>
      </div>
    )
  }
}

export default withFadeInUpAnimation(BlankCard)



// WEBPACK FOOTER //
// ./src/components/ui/cards/BlankCard.js